// extracted by mini-css-extract-plugin
export var chevron = "_2t-2";
export var chevronCollapsed = "_2t-3";
export var collapsibleHeader = "_2t-1";
export var container = "_2t-0";